/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.55"
        height="76.05"
        viewBox="0 0 95.55 76.05"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="m34.6.21-34 21a1.25 1.25 0 0 0-.41 1.72l.09.12.1.11a1.06 1.06 0 0 0 .29.22l59.3 31.85a1.21 1.21 0 0 0 1.22 0l33.78-20.72a1.26 1.26 0 0 0 0-2.14l-59-32.2a1.23 1.23 0 0 0-1.37.04Zm.76 2.48 56.45 30.82-31.35 19.21L3.77 22.21Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M.71 41.86a1.24 1.24 0 0 1 1 0l.13.07L60.41 73.4l33.11-20.31a1.29 1.29 0 0 1 1.05-.17h.12a1.26 1.26 0 0 1 .3 2.15l-.11.07-33.8 20.71a1.2 1.2 0 0 1-1.09.11l-.16-.08L.68 44.08a1.27 1.27 0 0 1-.45-.41l-.08-.13a1.26 1.26 0 0 1 .55-1.68Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M74.97 21.61a1.26 1.26 0 0 1-.27 1.65l-.12.08L41.84 44.1v20a1.27 1.27 0 0 1-1.13 1.25h-.12a1.26 1.26 0 0 1-1.25-1.12V43.42a1.27 1.27 0 0 1 .46-1l.12-.08 33.31-21.13a1.25 1.25 0 0 1 1.73.4Zm-19.4-10.55a1.25 1.25 0 0 1-.31 1.64l-.11.08-33.79 20.34v19.92a1.27 1.27 0 0 1-1.12 1.25h-.13a1.24 1.24 0 0 1-1.24-1.12V32.41a1.24 1.24 0 0 1 .49-1l.12-.08 34.39-20.7a1.24 1.24 0 0 1 1.7.43Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="m56.38 20.22-1.86 1.14-.3-.14-.31-.14a8.17 8.17 0 0 0-5.51-.34 9 9 0 0 0-2.81 1.31c-1.53 1.07-2.09 2.31-1.68 3.66a9.82 9.82 0 0 0 .77 1.72c.35.71.73 1.41 1.08 2.12s0 1.16-.82 1.58a3 3 0 0 1-2.71.19 5.25 5.25 0 0 1-.89-.51 1.84 1.84 0 0 1-.9-1.77c.11-.8.66-1.18 1.2-1.77l-3.33-1.38a5.5 5.5 0 0 0-1.92 2.92 3.32 3.32 0 0 0 1.26 3.05l-2.37 1.47 1.67 1.25 2.35-1.46c.42.2.81.41 1.23.59a9 9 0 0 0 8.57-1c1.42-1.08 2-2.28 1.6-3.58a15.43 15.43 0 0 0-1.25-2.63 11.38 11.38 0 0 1-.72-1.59.62.62 0 0 1 0-.53c.49-1.05 2.34-1.51 3.59-1 .86.35 1.29.88 1.24 1.59a2.82 2.82 0 0 1-.54 1.31c-.1.13-.19.27-.3.41l3.55 1a4.7 4.7 0 0 0 1.2-1.92 3.1 3.1 0 0 0-1.18-3.15l1.84-1.14Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M94.62 42.51h.14a1.26 1.26 0 0 1 .3 2.15l-.11.08-33.8 20.77a1.21 1.21 0 0 1-1.22 0L39.97 54.86a1.23 1.23 0 0 1-.47-1.69 1.26 1.26 0 0 1 1.57-.57l.12.06 19.25 10.33L93.5 42.74a1.34 1.34 0 0 1 .9-.2Zm-92.79-11L20.7 41.62a1.26 1.26 0 0 1 .5 1.7 1.24 1.24 0 0 1-1.56.56l-.12-.06L.68 33.69a.86.86 0 0 1-.2-.13l-.09-.08a1.25 1.25 0 0 1 1.44-2Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PaperMoneyStackIcon';

export default Icon;
